import Vue from 'vue'
import _ from 'lodash'
import {roomGroupApi} from "@/core/api/room.group.api";

export default {
    SET_ROOM_GROUP: function(state, roomGroupList) {
        const randomColor = () => {
            const letters = '0123456789ABCDEF'
            let color = '#'
            for (let i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)]
            }
            return color
        }

        roomGroupList.forEach(rg => {
            _.merge(rg, { color: randomColor() })

            let roomGroup = this.getters['roomGroup/getRoomGroup'](rg.roomGroupId)
            if(roomGroup) {
                Object.keys(rg)
                    .forEach((key) => {
                        if(roomGroup[key] === undefined) {
                            Vue.set(roomGroup, key, rg[key])
                        } else {
                            roomGroup[key] = rg[key]
                        }
                    })
            } else {
                Object.assign(rg, {
                    userList: [],
                    micMuteState: true,
                    speakerMuteState: true,
                })
                this.getters['roomGroup/roomGroupList'].push(rg)
            }
        })
    },
    CHANGE_ROOM_GROUP: function(state, data){
        const { roomGroupId, userId } = data

        this.getters['roomGroup/roomGroupList'].forEach(group=> {
            group.userList = group.userList.filter(user => (user.userId !== userId))
        })
        let me = this.getters['user/me']

        if(me.userId === userId) {
            me.roomGroupId = roomGroupId
        }
        /*
         *  미지정 그룹 ID = 'default'
         */
        let roomUser = this.getters['user/getRoomUser'](userId)
        roomUser.roomGroupId = roomGroupId

        if (roomGroupId != 'default') {
            this.getters['roomGroup/getRoomGroup'](roomGroupId).userList.push(roomUser)
        }
    },
    RESET_ROOM_GROUP: function(state, data){
        let roomGroupList = this.getters['roomGroup/roomGroupList']
        let roomGroupIds;
        if(data && data.roomGroupIds) {
            roomGroupIds = data.roomGroupIds
            if(!Array.isArray(roomGroupIds)) {
                roomGroupIds = [roomGroupIds]
            }
            roomGroupList = roomGroupList.filter(roomGroup => !!roomGroupIds.find(rg => rg == roomGroup.roomGroupId))
        }

        for(let i = 0; i<roomGroupList.length; i++) {
            if(roomGroupList[i].roomGroupId != 'default') {
                let roomGroup = roomGroupList[i];
                Vue.set(roomGroup, 'del', true)
                Vue.set(roomGroup, 'loaded', false)
                Vue.set(roomGroup, 'userList', [])
                Vue.set(roomGroup, 'speakerMuteState', true)
                Vue.set(roomGroup, 'micMuteState', true)
            }
        }
        if(!roomGroupIds) {
            this.getters['user/roomUserList'].forEach(ru => ru.roomGroupId = 'default')
        } else {
            this.getters['user/roomUserList'].forEach(ru => {
                if(roomGroupIds.findIndex(rg => rg == ru.roomGroupId) > -1) {
                    ru.roomGroupId = 'default'
                }
            })
        }

    },
    changeMode: function(state, {roomGroup}) {
        let rg = this.getters['roomGroup/getRoomGroup'](roomGroup.roomGroupId);
        if(!rg) {
            console.warn('roomGroup is null :', roomGroup);
            return;
        }
        rg.mode = roomGroup.mode;
    },

    SET_MODAL_REGISTER_SUBJECT: (state, {status, roomGroupId }) => {
        state.isModalSubject = status
        state.subjectRoomGroupId = roomGroupId
    },

    SET_NEW_USER: function(state, newStatus) {
        if (newStatus != undefined) {
            state.isNewUser = newStatus
            return
        }

        let isDefault = this.getters['user/roomUserList']
            .filter(ru => this.getters['user/isParticipantRole'](ru))
            .some(ru => !ru.roomGroupId || ru.roomGroupId == 'default')

        isDefault
            ? state.isNewUser = true
            : state.isNewUser = false
    },
    SET_LOADING_GROUP_MODE: function(state, loading) {
        // state.loadingGroupMode = loading
    },
    FINISH_LOADING_GROUP: function(state, roomGroupId) {
        let roomGroupList = this.getters['roomGroup/roomGroupList']
        let rg = roomGroupList.find(rg => rg.roomGroupId == roomGroupId);
        if(rg) {
            rg.loaded = true
        }
        // 내가 속한 그룹이 있을 경우
        if(roomGroupApi.isInRoomGroup()
            ||
        roomGroupList.findIndex(rg => !rg.del && !rg.loaded && rg.roomGroupId !== 'default') < 0
        ) {
            state.loadingGroupMode = false
        }
    },
    SET_SELECTED_PIN: function(state, value) {
        state.selectedPin = value
    },
    SET_SELECTED_USER_ID_LIST: function(state, userIdList) {
        state.selectedUserIdList = userIdList
    },
    SET_NEW_GROUP: function(state, status) {
        state.isSetNewGroup = status;
    },
    CHANGE_GROUP_SPEAKER: function(state, data) {
        const roomGroup = this.getters['roomGroup/getRoomGroup'](data.roomGroupId);
        if (!roomGroup) return;

        if (roomGroup.speakerMuteState === undefined) {
            Vue.set(roomGroup, 'speakerMuteState', data.mute)
        } else {
            roomGroup.speakerMuteState = data.mute;
        }
    },
    CHANGE_GROUP_MIC: function(state, data) {
        const roomGroup = this.getters['roomGroup/getRoomGroup'](data.roomGroupId);
        if (!roomGroup) return;

        if (roomGroup.micMuteState === undefined) {
            Vue.set(roomGroup, 'micMuteState', data.mute)
        } else {
            roomGroup.micMuteState = data.mute;
        }
    },
    CHANGE_VIDEO_LAYOUT_TYPE: function(state, data) {
        const roomGroup = this.getters['roomGroup/getRoomGroup'](data.roomGroupId);
        if (!roomGroup) return;

        roomGroup.videoLayout = data.videoLayout;
    }
}